import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppUriService } from '@app/core/services/app-uri.service';
import { MatIconRegistry } from '@angular/material/icon';

@Injectable({
  providedIn: 'root',
})
export class AuthIconsService {
  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
    private readonly appUriService: AppUriService
  ) {}

  public loadIcons(): void {
    this.iconRegistry.addSvgIconInNamespace(
      'popsy',
      'facebook',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.appUriService.domain}/assets/icons/facebook.svg`
      )
    );

    this.iconRegistry.addSvgIconInNamespace(
      'popsy',
      'google',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.appUriService.domain}/assets/icons/google.svg`
      )
    );

    this.iconRegistry.addSvgIconInNamespace(
      'popsy',
      'apple',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.appUriService.domain}/assets/icons/apple.svg`
      )
    );

    this.iconRegistry.addSvgIconInNamespace(
      'streamline',
      'view_1',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.appUriService.domain}/assets/icons/view-1.svg`
      )
    );

    this.iconRegistry.addSvgIconInNamespace(
      'streamline',
      'view_off',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.appUriService.domain}/assets/icons/view-off.svg`
      )
    );

    this.iconRegistry.addSvgIconInNamespace(
      'streamline',
      'keyboard_arrow_left',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.appUriService.domain}/assets/icons/keyboard-arrow-left.svg`
      )
    );

    this.iconRegistry.addSvgIconInNamespace(
      'streamline',
      'remove',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.appUriService.domain}/assets/icons/remove.svg`
      )
    );

    this.iconRegistry.addSvgIconInNamespace(
      'streamline',
      'arrow_left_1',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.appUriService.domain}/assets/icons/arrow-left-1.svg`
      )
    );
  }
}
